import React from 'react';
// import {Link} from "react-router-dom";

const FeaturedBlog = ({title,thumb,publishDate,id}) => {
    const blogURL = `blog/${title.split(' ').join('-').toLocaleLowerCase()}?id=${id}`;
    return (
        <div className="single-blog-item">
            <div className="post-thumb">
                <a href={blogURL}><img src={require('../../assets/img/' + thumb)} alt={title} /></a>
            </div>

            <div className="post-info">
                <h6><a href={blogURL}>{title}</a></h6>
                <span className="post-date"><i className="fa fa-clock-o"/>  {publishDate}</span>
            </div>
        </div>
    );
};

export default FeaturedBlog;